import React from 'react';
import { reactUrlToBrowserUrl } from '../../../../../../urlParse';
import MolLink from '../Menu/MolLink';
import { ProductCarouselModel } from '../ProductCarousel/Model';

import './index.scss';

interface BestsellerViewerProps {
  items: ProductCarouselModel[];
  title: string;
  allLink?: string;
  hasCookie: boolean;
}

export default class BestsellerViewer extends React.Component<BestsellerViewerProps> {
  render() {
    let allLink = null;

    let titleWraper = (
      <span className="bestseller-titel"> {this.props.title}</span>
    );

    if (this.props.allLink != undefined) {
      let htmlLink = reactUrlToBrowserUrl(this.props.allLink, null, null);
      allLink = (
        <div className="allLink">
          <MolLink to={this.props.allLink} href={htmlLink}>
            Alle Bestseller
          </MolLink>
        </div>
      );

      titleWraper = (
        <span className="bestseller-titel">
          <MolLink to={this.props.allLink} href={htmlLink}>
            {this.props.title}
          </MolLink>
        </span>
      );
    }

    return (
      <div className="bestseller">
        {titleWraper}

        {this.props.items != undefined
          ? this.props.items.map((item, index) => {
              let autorSpiped = null;
              if (item.autor != undefined && item.autor !="") {
                autorSpiped = (
                  <span className="buch-autor">
                    von{' '}
                    {item.autor.split('|').reduce((r1, r2) => {
                      return r1 + ' und ' + r2;
                    })}
                  </span>
                );
              }

              return (
                <div className="search_tr" key={'search_tr_' + index}>
                  <MolLink
                    to={'/product_info/' + item.products_id}
                    href={item.link}
                  >
                    <div className="search_td_platz">{index + 1}.</div>
                    <div className="search_td_bild">
                      <img
                        src={
                          'https://media.moluna.de/images/bilder/' +
                          item.products_image
                        }
                      />
                    </div>
                    <br />
                    <div className="search_td_res"></div>
                    <div className="search_td">
                      <span className="buch-titel">
                        {item.bezeichnung}
                        <br />
                      </span>
                      <br />
                      {autorSpiped}
                      <br />
                      <br />
                      {this.props.hasCookie ? (
                        <span className="buch-preis">
                          {parseFloat(item.price + '').toFixed(2)} €
                        </span>
                      ) : null}
                    </div>
                  </MolLink>
                </div>
              );
            })
          : null}
        {allLink}
      </div>
    );
  }
}
